import { observer } from "mobx-react-lite";

import {
  Dialog,
  Heading,
  Link,
  PrimaryButton,
  Stack,
  Text
} from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";

export const ExportPatientRecordPasswordDialog = observer(() => {
  const { practice } = useStores();
  const patientLabelCapitalised = usePatientLabel(true);
  const patientLabel = usePatientLabel();

  const {
    masterPatient,
    exportRecordValues,
    setShowExportPatientRecordPasswordDialog
  } = practice.ui;

  const handleDismiss = () => setShowExportPatientRecordPasswordDialog(false);

  const handleCopyPassword = () => {
    if (exportRecordValues?.password) {
      navigator.clipboard.writeText(exportRecordValues.password);
    }
  };

  return (
    <Dialog
      hidden={false}
      minWidth={650}
      onDismiss={handleDismiss}
      dialogContentProps={{
        showCloseButton: true,
        title: (
          <Heading variant="modal-heading">
            {patientLabelCapitalised} export
          </Heading>
        )
      }}
    >
      <Stack tokens={{ childrenGap: 16 }}>
        <Text>{`A download link for the ${patientLabel} export PDF will be emailed to you when available.`}</Text>
        <Text>{`Use the following password to access the ${patientLabel} export document for ${masterPatient?.fullName}`}</Text>
        <Stack horizontal tokens={{ childrenGap: 5 }}>
          <Text>{exportRecordValues?.password}</Text>
          <Link onClick={handleCopyPassword}>Copy</Link>
        </Stack>
        <Stack horizontalAlign="end">
          <PrimaryButton onClick={handleDismiss} text="Close" />
        </Stack>
      </Stack>
    </Dialog>
  );
});
